var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.023.153H6.877C3.157.157.143 3.315.14 7.213v11.679c0 1.66 1.284 3.006 2.87 3.006h9.598c1.585 0 2.87-1.346 2.87-3.006v-4.665h2.475c2.192 0 3.91-3.091 3.91-7.04 0-3.868-1.65-6.914-3.781-7.032h-.058V.153zM6.877 1.656h8.63c-.899 1.278-1.468 3.257-1.468 5.531v6.198H1.573V7.212C1.577 4.145 3.95 1.66 6.877 1.656zm5.74 18.739H3.008c-.792 0-1.435-.673-1.435-1.503v-4.009h12.469v4.009c0 .83-.643 1.503-1.435 1.503h.01zm2.87-7.719l.033.048h-.034v-.048zm4.95-5.486c0 3.257-1.304 5.536-2.476 5.536s-2.475-2.274-2.475-5.536c0-3.262 1.275-5.502 2.449-5.534h.052c1.143.032 2.44 2.295 2.44 5.531l.01.003z",
    transform: "translate(-308 -738) translate(0 721) translate(303.5 17) translate(4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.952 4.341c-1.017 0-1.782 1.226-1.782 2.849 0 1.623.765 2.848 1.782 2.848 1.016 0 1.781-1.225 1.781-2.848 0-1.623-.765-2.849-1.781-2.849zm0 4.162c-.13-.14-.347-.597-.347-1.316 0-.719.215-1.175.347-1.315.129.14.346.596.346 1.315 0 .72-.217 1.175-.346 1.316z",
    transform: "translate(-308 -738) translate(0 721) translate(303.5 17) translate(4.5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollupIcon);
export default __webpack_public_path__ + "static/media/rollupIcon.d0d47c870be294def8aa7b1217e08371.svg";
export { ForwardRef as ReactComponent };